<template>
  <div class="pagination-wrapper">
    <div class="pagination">
      <a class="prev page-numbers" @click="setPage('first')">
        <i class="fas fr fa-angle-left" />
        <i class="fas fr fa-angle-left" />
      </a>
      <a class="prev page-numbers" @click="setPage('prev')">
        <i class="fas fr fa-angle-left" />
      </a>
      <span aria-current="page" class="page-numbers current">
        <input
          type="text"
          class="page"
          v-model="page"
          @change="setPage"
          v-int
        />
      </span>
      <a class="next page-numbers">
        <i class="fas fr fa-angle-right" @click="setPage('next')" />
      </a>
      <a class="next page-numbers" @click="setPage('last')">
        <i class="fas fr fa-angle-right" />
        <i class="fas fr fa-angle-right" />
      </a>
    </div>
    <div class="text-logo">{{ totalPages }} páginas totales</div>
    <div class="text-logo mt-2">
      <input type="text" class="size" v-model="size" v-int @change="setSize" />
      elementos por página
    </div>
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: ["currentPage", "totalPages", "sizeList"],
  data() {
    return {
      page: 1,
      size: 12,
    };
  },
  methods: {
    setPage(e) {
      let val;

      switch (e) {
        case "first":
          val = 1;
          break;
        case "last":
          val = this.totalPages;
          break;
        case "next":
          val = this.page + 1;
          break;
        case "prev":
          val = this.page - 1;
          break;

        default:
          val = e.target.value;
      }

      if (val) {
        if (val > this.totalPages) val = this.totalPages;
        if (val < 1) val = 1;
        this.page = val;
        this.$emit("setPage", val - 1);
      }
    },
    setSize(e) {
      let val = e.target.value;

      if (val) {
        if (val < 1) val = 1;
        this.page = 1;
        this.$emit("setSize", val);
      }
    },
  },
  mounted() {
    this.page = this.currentPage + 1;
    this.size = this.sizeList;
  },
};
</script>

<style lang="scss" scoped>
//----------  responsive breakpoints
//------------------------------------------------------------------------------
@mixin breakpoint($value) {
  @if $value == "phone" {
    @media only screen and (min-width: 120px) and (max-width: 767px) {
      @content;
    }
  } @else if $value == "tablet" {
    @media only screen and (min-width: 768px) and (max-width: 1024px) {
      @content;
    }
  } @else if $value == "touch" {
    @media only screen and (min-width: 120px) and (max-width: 1024px) {
      @content;
    }
  } @else if $value == "desktop" {
    @media only screen and (min-width: 1025px) {
      @content;
    }
  } @else {
    @media only screen and (max-width: $value) {
      @content;
    }
  }
}

// Colors
$white: #fff;
$black: #000;
$grey: #595959;
$grey-dark: #2b2b2b;
$grey-light: #eee;
$green: #86c023;
$blue: #017ac7;
$logo: var(--color-logo);

// Transition
$duration: 400ms;
$easing: ease;

//----------  reset
//------------------------------------------------------------------------------
htm,
body {
  font-family: sans-serif;
}

a {
  text-decoration: none;
}

//----------  pagination
//------------------------------------------------------------------------------

//----------  pagination
//------------------------------------------------------------------------------
.pagination-wrapper {
  text-align: center;
  margin: 40px 0;
}

.pagination {
  display: inline-block;
  height: 70px;
  margin-top: 70px;
  padding: 0 25px;
  border-radius: 35px;
  background-color: $grey-light;

  @include breakpoint(1199px) {
    height: 50px;
    margin-top: 50px;
    padding: 0 10px;
    border-radius: 25px;
  }
}

.page-numbers {
  display: block;
  padding: 0 25px;
  float: left;
  transition: $duration $easing;
  color: $grey;
  font-size: 20px;
  letter-spacing: 0.1em;
  line-height: 70px;

  &:hover,
  &.current {
    background-color: $logo;
    color: $white;
  }

  &.prev:hover,
  &.next:hover {
    background-color: transparent;
    color: $logo;
  }

  @include breakpoint(1199px) {
    padding: 0 15px;
    font-size: 16px;
    line-height: 50px;
  }

  @include breakpoint(touch) {
    padding: 0 14px;
    display: none;

    &:nth-of-type(2) {
      position: relative;
      padding-right: 50px;

      &::after {
        content: "...";
        position: absolute;
        font-size: 25px;
        top: 0;
        left: 45px;
      }
    }

    &:nth-child(-n + 3),
    &:nth-last-child(-n + 3) {
      display: block;
    }

    &:nth-last-child(-n + 4) {
      padding-right: 14px;

      &::after {
        content: none;
      }
    }
  }
}

.page,
.page:focus {
  background: transparent;
  border: transparent;
  outline: none;
  box-shadow: none;
  color: white;
  width: 40px;
  padding: 0px;
  text-align: center;
  margin: 0;
  position: absolute;
  top: 50%;
  left: calc(50% - 20px);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.page-numbers.current {
  height: 100%;
  position: relative;
}

.size {
  display: initial;
  width: 40px;
  height: 30px;
}
</style>
